// only run the function if countdown wrapper exists
const countdownElement = document.getElementsByClassName('countdown-wrapper')
let allowedToRun

if (countdownElement.length > 0) {
  allowedToRun = true
} else {
  allowedToRun = false
}

const fn = {
  init: () => {
    let date = document.querySelector('#countdown').dataset.countdown
    let headlineAfter = document.querySelector('#countdownHeadline').dataset.after

    fn.startCountdown(date, headlineAfter)
  },

  startCountdown: (date, headline) => {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24

    const countDown = new Date(date).getTime(),
      startCountdown = setInterval(function () {
        const now = new Date().getTime(),
          distance = countDown - now

        ;(document.getElementById('countdown-days').innerText = Math.floor(distance / day)),
          (document.getElementById('countdown-hours').innerText = Math.floor((distance % day) / hour)),
          (document.getElementById('countdown-minutes').innerText = Math.floor((distance % hour) / minute)),
          (document.getElementById('countdown-seconds').innerText = Math.floor((distance % minute) / second))

        //when date is reached
        if (distance < 0) {
          if (headline != null) {
            document.getElementById('countdownHeadline').innerText = headline
          } else {
            document.getElementById('countdownHeadline').innerText = ''
          }

          document.getElementById('countdown').style.display = 'none'

          if (document.getElementById('completionContent')) {
            document.getElementById('completionContent').style.display = 'block'
          }

          clearInterval(startCountdown)
        }
      }, 0)
  },
}

export default {
  can: () => allowedToRun,
  run: fn.init,
}
